import { createApp } from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// +++++++ Essential Components     +++++++ +++++++ +++++++ +++++++ +++++++ +++++++ +++++++ //
import PrPreLoaderFull from "@/components/custom/PrPreLoaderFull.vue";

// +++++++ Number Formatting Directives and Filters +++++++ +++++++ +++++++ +++++++ +++++++ //
import { numberFormat, numberFormatCleanup } from "@/directives/numberFormat";
import { installNumberFilters } from "@/filters/numberFilters";
import { DEFAULT_COMMISSION_TIERS, DEFAULT_TRADE_SETTINGS } from "@/utils/tradeSettings";
import { getCmsText } from "@/services/siteCms";

// ####### END Essential Components ####### ####### ####### ####### ####### ####### ####### //

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

const app = createApp(App);

// Load public settings at bootstrap to provide app-wide defaults
(async () => {
  try {
    const res = await axios.get('/v2/settings/public');
    const s = res?.data?.data || {};
    window.__appSettings = {
      decimalGoldLimit: typeof s.decimalGoldLimit === 'number' ? s.decimalGoldLimit : 3,
      decimalIrrLimit: typeof s.decimalIrrLimit === 'number' ? s.decimalIrrLimit : 0,
      decimalDefault: typeof s.decimalIrrLimit === 'number' ? s.decimalIrrLimit : 0,
      inviteRewardAmount: s.inviteRewardAmount || 0,
      inviteText: s.inviteText || '',
      buyPriceOffsetToman:
        typeof s.buyPriceOffsetToman === "number"
          ? s.buyPriceOffsetToman
          : DEFAULT_TRADE_SETTINGS.buyPriceOffsetToman,
      sellPriceOffsetToman:
        typeof s.sellPriceOffsetToman === "number"
          ? s.sellPriceOffsetToman
          : DEFAULT_TRADE_SETTINGS.sellPriceOffsetToman,
      commissionTiers: Array.isArray(s.commissionTiers) && s.commissionTiers.length > 0
        ? s.commissionTiers
        : DEFAULT_COMMISSION_TIERS,
    };
  } catch (_) {
    window.__appSettings = {
      decimalGoldLimit: 3,
      decimalIrrLimit: 0,
      decimalDefault: 0,
      inviteRewardAmount: 0,
      inviteText: '',
      buyPriceOffsetToman: DEFAULT_TRADE_SETTINGS.buyPriceOffsetToman,
      sellPriceOffsetToman: DEFAULT_TRADE_SETTINGS.sellPriceOffsetToman,
      commissionTiers: DEFAULT_COMMISSION_TIERS,
    };
  }
})();

// Install number formatting directive
app.directive('number-format', numberFormat);
app.directive('number-format-cleanup', numberFormatCleanup);
// Keeps page markup and layout untouched; only a saved text value replaces
// the element's visible text after the page has rendered.
app.directive('cms-text', {
  mounted(el, binding) {
    const fallback = el.textContent;
    getCmsText(binding.value, fallback).then((value) => {
      if (value !== fallback) el.textContent = value;
    });
  },
});

// Install number formatting filters
installNumberFilters(app);

app
  .use(Toast, {
    transition: "Vue-Toastification__fade",
    maxToasts: 20,
    newestOnTop: true,
  })
  .use(store)
  .component("PrPreLoaderFull", PrPreLoaderFull)
  .use(router)
  .mount("#app");
